<div class="avano-checkbox-container" [class.avano-checkbox-disabled]="disabled" [class.avano-checkbox-readonly]="readonly">
  <div class="avano-checkbox-hidden">
    <input
      #cb
      class="avano-checkbox"
      type="checkbox"
      [attr.name]="name"
      [attr.value]="value"
      [checked]="checked()"
      (focus)="onInputFocus()"
      [disabled]="disabled || readonly"
      (change)="handleChange($event)"
      [required]="required"
      (blur)="onBlur()"
    />
  </div>
  <div class="avano-checkbox-box" (click)="onClick($event, cb, true)">
    <span [ngClass]="checked() ? 'icon-content-check' : null"></span>
  </div>
  <label (click)="onClick($event, cb, true)">
    <ng-content></ng-content>
  </label>
</div>
